import { render, staticRenderFns } from "./SettingsScreen.vue?vue&type=template&id=6a064b7c&scoped=true&"
import script from "./SettingsScreen.vue?vue&type=script&lang=ts&"
export * from "./SettingsScreen.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsScreen.vue?vue&type=style&index=0&id=6a064b7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a064b7c",
  null
  
)

export default component.exports